<template>
    <div>
        <m-assembly-table :total="total"
                        :loading="loading"
                        :formData="formData"
                        :columns="columns"
                        :settings="settings"
                        :data="tableData"
                        @onSubmit="onSubmit"
                        @onPageSizeChange="onPageSizeChange"
                        @onCurrentPageChange="onCurrentPageChange"
                        ref="table">
                        <div slot="tableHeader">
                            <div style="overflow:hidden;">
                                <div style="float:left;">
                                    <!-- <a id="anchor1" style="margin-left:10px;"><Button type="primary" :disabled="tableData.length === 0" :loading="loading" @click="exportExcel">导出</Button></a> -->
                                    <!-- 导出 -->
                                    <Button style="margin: 0 10px;" type="primary" @click="exportExcel">{{$t('commonTw.t1')}}</Button>
                                    <set-table :columns="columns.columns" @setTableUpdate="setTableUpdate"></set-table>
                                </div>
                            </div>
                        </div>
        </m-assembly-table>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
// import ExcellentExport from 'excellentexport';
import { qmsApiSwitch, qmsApiSwitch2 } from '@/utils/tool';
export default {
  name: 'typeTestReportSearch',
  components: {
    mAssemblyTable
  },
  data () {
      return {
          total: 0,
          page: 1,
          pageSize: 10,
          loading: false,
          QUERY_TYPE: 1,
          formData: {
              row: 2,
              items: [
                // {
                //     value: 0,
                //     field: 'QUERY_TYPE',
                //     layout: {
                //     span: 8,
                //     row: 1
                //     },
                //     options: {
                //     multiple: false,
                //     values: [
                //         // {
                //         //     label: this.$t('typeTestProcessSearch.t17'), // 工厂级别
                //         //     value: 0
                //         // },
                //         // {
                //         //     label: this.$t('typeTestProcessSearch.t18'), // 事业部级别
                //         //     value: 1
                //         // }
                //     ]
                //     },
                //     validators: {
                //         required: {
                //             required: false,
                //             message: this.$t('typeTestProcessSearch.t19') // `不能为空
                //         }
                //     },
                //     hide: true,
                //     type: 'select',
                //     title: this.$t('typeTestProcessSearch.t20'), // 查询类型
                //     methods: {
                //         change: () => {
                //             let val = this.getFormDataItemVal(this.formData.items, 'QUERY_TYPE');
                //             this.QUERY_TYPE = val;
                //             if (val) {
                //                 this.$set(this.formData.items[1], 'field', 'INV_ORG_ID');
                //                 this.$set(this.formData.items[1], 'title', this.$t('typeTestProcessSearch.t4')); // 事业部
                //                 this.$set(this.formData.items[1].options, 'values', this.ouList);
                //             } else {
                //                 this.$set(this.formData.items[1], 'field', 'ORG_ID');
                //                 this.$set(this.formData.items[1], 'title', this.$t('typeTestProcessSearch.t21')); // 库存组织
                //                 this.$set(this.formData.items[1].options, 'values', this.orgList);
                //             }
                //         }
                //     }
                // },
                {
                    value: '',
                    field: 'ORG_ID',
                    layout: {
                    span: 8,
                    row: 1
                    },
                    options: {
                    multiple: false,
                    values: []
                    },
                    validators: {
                        required: {
                            required: true,
                            message: this.$t('不能为空') // 不能为空
                        }
                    },
                    type: 'select',
                    title: this.$t('typeTestProcessSearch.t21') // 库存组织
                },
                {
                    value: '',
                    field: 'ITEM_CODE',
                    disabled: false,
                    placeholder: '',
                    layout: {
                        span: 8,
                        offset: 0,
                        row: 1
                    },
                    options: {
                        rows: 1,
                        type: 'text'
                    },
                    type: 'text',
                    title: this.$t('typeTestProcessSearch.t11') // 物料编码
                },
                {
                    value: '',
                    field: 'CHECKED_TIME_FROM',
                    layout: {
                        row: 2,
                        span: 8,
                        offset: 0
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd 00:00:00'
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: this.$t('typeTestProcessSearch.t23'), // 检验时间
                    placeholder: '',
                    isDouble: true
                },
                {
                    hide: true,
                    value: '',
                    field: 'CHECKED_TIME_TO',
                    layout: {
                        span: 8,
                        offset: 0,
                        row: 2
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd 23:59:59'
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: ''
                },
                {
                    value: '',
                    field: 'ENTRUST_DATE_FROM',
                    layout: {
                        row: 2,
                        span: 8,
                        offset: 0
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd 00:00:00'
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: this.$t('typeTestProcessSearch.t24'), // 委托时间
                    placeholder: '',
                    isDouble: true
                },
                {
                    hide: true,
                    value: '',
                    field: 'ENTRUST_DATE_TO',
                    layout: {
                        span: 8,
                        offset: 0,
                        row: 2
                    },
                    options: {
                        type: 'date',
                        format: 'yyyy-MM-dd 23:59:59'
                    },
                    style: 'width:100%',
                    type: 'datePicker',
                    title: ''
                }
              ]
          },
          columns: {
            columns: [
                {
                    title: '序号',
                    minWidth: 40,
                    align: 'center',
                    key: ''
                },
                // {
                //     title: 'ID',
                //     width: 150,
                //     render: (h, params) => {
                //         return h('span', {
                //             style: {
                //                 color: 'blue',
                //                 cursor: 'pointer'
                //             },
                //             on: {
                //                 click: () => {
                //                     let locationName = window.environment.isPro ? 'http://qmsapi.midea.com' : 'http://qmsuat2.midea.com';
                //                     console.log(`${locationName}/iqc/ExaminedTypetest/Report?ID=${params.row.ID}&ORG_ID=${this.QUERY_TYPE ? this.getFormDataItemVal(this.formData.items, 'INV_ORG_ID') : this.getFormDataItemVal(this.formData.items, 'ORG_ID')}&FromExternal=1`);
                //                     // return false;
                //                     // window.open(`${locationName}/iqc/ExaminedTypetest/Report?ID=${params.row.ID}&ORG_ID=${this.QUERY_TYPE ? this.getFormDataItemVal(this.formData.items, 'INV_ORG_ID') : this.getFormDataItemVal(this.formData.items, 'ORG_ID')}&FromExternal=1`);
                //                 }
                //             }
                //         }, params.row.ID);
                //     }
                // },
                {
                    title: this.$t('typeTestProcessSearch.t21'), // 库存组织
                    minWidth: 200,
                    align: 'center',
                    key: 'ORG_NAME',
                    render: (h, params) => {
                        let n = params.row.ORG_NAME.indexOf('_') + 1;
                        return h('div', {
                            style: {
                                textAlign: 'left'
                            }
                        }, [
                            h('span', params.row.ORG_NAME.substr(n))
                        ]);
                    }
                },
                {
                    title: this.$t('typeTestProcessSearch.t6'), // 状态
                    width: 80,
                    key: 'STATUS_TL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t25'), // 送货单号
                    minWidth: 100,
                    key: 'BARCODE_NUMBER_TL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t26'), // 型式试验单号
                    minWidth: 140,
                    key: 'EXAMINED_NO',
                    render: (h, params) => {
                            return h('span', {
                                style: {
                                    color: 'blue',
                                    cursor: 'pointer'
                                },
                                on: {
                                    click: () => {
                                        const locationName = qmsApiSwitch2(this, window.environment.isPro ? 'https://qms.midea.com' : 'https://qmsuat.midea.com', this.getOrgCode(this.getFormDataVModel(this.formData.items).ORG_ID));
                                        window.open(`${locationName}/iqc/ExaminedTypetest/ViewReport?id=${params.row.ID}&FromExternal=1`);
                                    }
                                }
                            }, params.row.EXAMINED_NO);
                        }
                },
                {
                    title: this.$t('typeTestProcessSearch.t8'), // 试验类型
                    minWidth: 110,
                    key: 'TYPETEST_TYPE_TL'
                },
                // {
                //     title: '供应商编码',
                //     minWidth: 120,
                //     key: 'SUPPLIER_CODE'
                // },
                // {
                //     title: '供应商描述',
                //     minWidth: 200,
                //     key: 'SUPPLIER_DESC',
                //     render: (h, params) => {
                //         return h('Tooltip', {
                //             props: {
                //                 content: params.row.SUPPLIER_DESC,
                //                 placement: 'top'
                //             },
                //             class: 'm-tooltip-overflow'
                //         }, params.row.SUPPLIER_DESC);
                //     }
                // },
                {
                    title: this.$t('typeTestProcessSearch.t11'), // 物料编码
                    minWidth: 130,
                    key: 'ITEM_CODE'
                },
                {
                    title: this.$t('typeTestProcessSearch.t12'), // 物料描述
                    minWidth: 200,
                    key: 'ITEM_DESC',
                    render: (h, params) => {
                        return h('Tooltip', {
                            props: {
                                content: params.row.ITEM_DESC,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                        }, params.row.ITEM_DESC);
                    }
                },
                {
                    title: this.$t('typeTestProcessSearch.t27'), // 物料型号
                    minWidth: 200,
                    key: 'PRODUCT_MODEL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t28'), // 大类
                    minWidth: 100,
                    key: 'BIG_CLASS_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t29'), // 中类
                    minWidth: 100,
                    key: 'MID_CLASS_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t30'), // 小类
                    minWidth: 150,
                    key: 'SMALL_CLASS_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t24'), // 委托时间
                    minWidth: 150,
                    key: 'DELIVERY_DATE_TL',
                    align: 'center'
                },
                {
                    title: this.$t('typeTestProcessSearch.t31'), // 检验结果
                    minWidth: 70,
                    key: 'CHECKED_RESULT_TL',
                    align: 'center'
                },
                {
                    title: this.$t('typeTestProcessSearch.t32'), // 是否已审批
                    minWidth: 50,
                    key: 'FLOW_STATUS',
                    align: 'center'
                },
                {
                    title: this.$t('typeTestProcessSearch.t23'), // 检验时间
                    minWidth: 150,
                    key: 'CHECKED_TIME_TL',
                    align: 'center'
                },
                {
                    title: this.$t('typeTestProcessSearch.t33'), // 检验员
                    minWidth: 100,
                    key: 'CHECKER_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t34'), // 认领人
                    minWidth: 100,
                    key: 'CLAIMER_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t35'), // 委托人
                    minWidth: 100,
                    key: 'ENTRUST_USER_NAME'
                },
                {
                    title: this.$t('typeTestProcessSearch.t36'), // 结果描述
                    minWidth: 150,
                    key: 'PROBLEM_DESC',
                    render: (h, params) => {
                        return h('Tooltip', {
                            props: {
                                content: params.row.PROBLEM_DESC,
                                placement: 'top'
                            },
                            class: 'm-tooltip-overflow'
                        }, params.row.PROBLEM_DESC);
                    }
                },
                {
                    title: this.$t('typeTestProcessSearch.t37'), // 特性分级
                    minWidth: 70,
                    key: 'QTY_CHARACTERISTIC',
                    align: 'center'
                },
                {
                    title: this.$t('typeTestProcessSearch.t38'), // 停用日期
                    minWidth: 150,
                    key: 'FINISH_DATE_TL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t39'), // 整改日期
                    minWidth: 150,
                    key: 'PDC_START_DATE_TL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t40'), // 整改完成时间
                    minWidth: 150,
                    key: 'PDC_END_DATE_TL'
                },
                {
                    title: this.$t('typeTestProcessSearch.t41'), // 整改期间是否有收货
                    minWidth: 70,
                    key: 'PDAC_RECEIPT_TL',
                    align: 'center'
                }
            ]
          },
          settings: {
            needPager: true,
            showElevator: true,
            showSizer: true,
            pageSizeOpts: [10, 30, 50, 80],
            needSearch: true,
            needValidation: true
          },
          tableData: [],
          tableDataAll: [],
          ouList: [],
          orgList: [],
      };
  },
  methods: {
    switchLanguageToQms(lang) {
        // QMS语言 ZH_CN=中文，EN_US=英文，JA_JP=日语，EN_TH=泰语，VI_VN=越南语 
        switch (lang) {
            case 'zh-CN':
            return 'ZH_CN';
            break;
            case 'en-US':
            return 'EN_US';
            break;
            case 'th':
            return 'EN_TH';
            break;
        }
    },
    onSubmit (pageIndex, pageSize) {
      this.page = pageIndex;
      this.pageSize = pageSize;
      this.loading = true;
      let formData = this.getFormDataVModel(this.formData.items, true);
      formData.QUERY_TYPE = 0;
      let language = this.switchLanguageToQms(this.$i18n.locale);
      axios.get(qmsApiSwitch(this, '/qms2gsc/RptExaminedTypetestReport/GetTypetestReportListForeign', this.getOrgCode(formData.ORG_ID)), {
          params: {
              model: JSON.stringify({
                ...formData,
                PAGER: this.page,
                PAGESIZE: this.pageSize,
                SUPPLIER_CODE: this.mdmCode, // this.vendorCode,
                mdmCode: this.mdmCode,
                language: language
            })
          }
      })
      .then((res) => {
          let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
          this.loading = false;
          this.tableData = resp.MainResultData.DATA;
          this.total = resp.MainResultData.TOTAL;
      })
      .catch(() => {
        this.loading = false;
        this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('common.error1')
        });
      });
        // axios.get('/qms2gsc/RptExaminedTypetestReport/GetTypetestReportList', {
        //     params: {
        //         model: JSON.stringify({
        //         ...formData,
        //         PAGER: this.page,
        //         PAGESIZE: 9999,
        //         SUPPLIER_CODE: this.vendorCode
        //     })
        //     }
        // })
        // .then((res) => {
        //     let resp = JSON.parse(res.data.substring(1).substring(0, res.data.length - 3));
        //     this.tableDataAll = resp.MainResultData.DATA;
        // });
    },
    onPageSizeChange (page, pageSize) {
        this.onSubmit(page, pageSize);
    },
    onCurrentPageChange (page, pageSize) {
        this.onSubmit(page, pageSize);
    },
    getOrgList () {
        this.getSRMInvLovListNew((data) => {
            let list = [];
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.erpOrgId
                });
            });
            console.log('777---', list);
            this.orgList = data;
            this.$set(this.formData.items[0].options, 'values', list);
        });
    },
    // getOuList () {
    //     debugger;
    //     // axios.get('/gscapp/lov/getBULovNew?UP=Y&SITE=Y&ASL=N&labelName=buName&valueName=buId')
    //     axios.get('/gscint/vendor/getOverSeaBuList', {
    //         params: {
    //             SITE: 'Y',
    //             ASL: 'N'
    //         }
    //     })
    //     .then((res) => {
    //         const data = res.data.data.datas;
    //         data.forEach((item) => {
    //             item.label = item.buName;
    //             item.value = item.buId;
    //         });
    //         this.ouList = data;
    //     });
    // },
    // // 导出
    // exportExcel2 () {
    //     this.loading = true;
    //     let excelName = '型式试验报表';
    //     let excelColumns = this.columns.columns;
    //     let id = 'anchor1';
    //     const options = {
    //         anchor: id,
    //         filename: excelName,
    //         format: 'xlsx'
    //     };
    //     let columns = [];
    //     excelColumns.map((item) => {
    //         if (item.title && item.title !== 'ID') {
    //             columns.push(item.title);
    //         }
    //     });
    //     let datas = [];
    //     this.tableDataAll.map((item, key) => {
    //         datas.push([]);
    //         excelColumns.map((item2) => {
    //             if (item2.title && item2.title !== 'ID') {
    //                 datas[key].push(item[item2.key]);
    //             }
    //         });
    //     });
    //     const sheets = [
    //         {
    //             name: excelName,
    //             from: {
    //                 array: [
    //                     columns,
    //                     ...datas
    //                 ]
    //             }
    //         }
    //     ];
    //     console.log('sheets', sheets);
    //     ExcellentExport.convert(options, sheets);
    //     setTimeout(() => {
    //         this.loading = false;
    //     }, 3000);
    // },
    exportExcel () {
        if (!this.$refs.table.validateForm()) return;
        let formData = this.getFormDataVModel(this.formData.items, true);
        const hostname = qmsApiSwitch2(this, window.environment.isPro ? 'https://qmsapi.midea.com' : 'https://qmsuatapi.midea.com', this.getOrgCode(formData.ORG_ID))
        let language = this.$i18n.locale == 'zh-CN' ? 'zh-CN' : 'US';
        let model = JSON.stringify({
                ...formData,
                PAGER: this.page,
                PAGESIZE: 9999,
                SUPPLIER_CODE: this.mdmCode, // this.vendorCode,
                language: language,
                isSaveLog: this.isPro() ? 'N' : 'Y', // 生产环境传N，测试环境传Y
                mdmCode: this.mdmCode,
                QUERY_TYPE: 0
            });
        window.open(`/gscint/gscTypeTestInfo/exportTypetestReportList?language=${language}&isSaveLog=${this.isPro() ? 'N' : 'Y'}&url=${encodeURIComponent(`${hostname}/qms2gsc/RptExaminedTypetestReport/GetTypetestReportListForeign?model=${model}`)}`);
    },
    setTableUpdate (columns) {
        this.columns.columns = columns;
    },
    queryVendorAndMdm() {
        axios.post('/gscint/vendor/queryVendorAndMdm', {
            vendorCode: this.vendorCode
        }).then((res) => {
            this.mdmCode = res.data.data.datas.mdmCode;
        });
    },
    getOrgCode(orgId) {
        return this.orgList.find((item) => item.erpOrgId === orgId).organizationCode;
    },
  },
  mounted () {
      this.queryVendorAndMdm();
    //   this.vendorCode = JSON.parse(localStorage.getItem('supplierInfo')).vendorCode;
      this.getOrgList();
      // this.getOuList();
  }
};
</script>
<style lang="less" scoped>
.layout {
  background: #FFF;
}
</style>
